import React from "react";
import ContactPersonFullCard from "../ContactPersonFullCard/ContactPersonFullCard";
import ContactPersonInfo from "../ContactPersonInfo/ContactPersonInfo";
import depthPortfolio from "../../assets/images/svg/depthPortfolio.svg";
import planAnalysis from "../../assets/images/svg/planAnalysis.svg";
import riskAnalysis from "../../assets/images/svg/riskAnalysis.svg";
import financialStratergies from "../../assets/images/svg/financialStratergies.svg";
import { observer } from "mobx-react";
import UserStore from "../../store/UserStore";

const Person1Tab = observer(() => {
  const selectedContact = UserStore?.selectedContact;
  return (
    <div
      className={`person1_tab_outer ${selectedContact.className ? selectedContact.className : ""}`}
    >
      <div className="person1_tab_inside">
        <ContactPersonFullCard
          photo={UserStore.connectImages[selectedContact?.id]}
          name={selectedContact?.name}
          position={selectedContact?.role}
          phoneNum={selectedContact?.contactNo}
          emailId={selectedContact?.emailId}
        />
        <div
          className="person1_tab_info"
          dangerouslySetInnerHTML={{ __html: selectedContact?.bioRTF }}
        ></div>
      </div>
      {selectedContact?.expertise && selectedContact?.expertise?.length && (
        <>
          <h2 className="helptext">
            {selectedContact?.name.split(" ")[0]}{" "}
            <span>can help you with...</span>
          </h2>
          <div className="person1_tab_info_div">
            {selectedContact?.expertise?.map((item, index) => (
              <ContactPersonInfo
                photo={
                  [
                    depthPortfolio,
                    planAnalysis,
                    riskAnalysis,
                    financialStratergies,
                  ][index]
                }
                text={item}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
});

export default Person1Tab;
